export const paginationLimit = 25;
export const nodeListPaginationLimit = 15
export const nodeBrowserPaginationLimit = 25;
